import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Facture } from 'src/app/entity/Facture';
import { FactureService } from 'src/app/service/facture.service';
 

@Component({
  selector: 'app-facture-dialog',
  templateUrl: './facture-dialog.component.html',
  styleUrls: ['./facture-dialog.component.css']
})
export class FactureDialogComponent implements OnInit {

@Input() visible:boolean;
@Input() facture:Facture;
@Output() closeFacture:EventEmitter<any> = new EventEmitter(); 

  constructor(private factureService:FactureService) { }

  ngOnInit() {
  }
close(){
  this.closeFacture.emit()
}
show(){
  this.factureService.nextInvoice(this.facture)

}


}
